import { fetchData } from "@redux/slices/functionals/request/requestActions";
import { IUser } from "@ts/ui-models";

export const getUsers = async (
    dispatch,
    id: string | string[] | undefined
): Promise<IUser | IUser[] | null> => {
    if (!id) return null;
    const result = await dispatch(
        fetchData({
            key: 'getUsers',
            url: `/api/users`,
            dataBody: { where: { logicalId: id } },
            withoutCancel: true,
        })
    );
    if (result?.payload?.data) {
        return Array.isArray(id) ? result.payload.data.rows : result.payload.data.rows[0];
    }
    return null;
};